import { useState } from "react";
import { getFeatureString } from "../getFeatureString";
import { IpaChart } from "./IpaChart";
import { IpaType } from "../../phonemes/ipa";
import { worldAllophones } from "../../transmogrify/allophones";
import { hasSample, speakSample } from "./speakSample";

/** IPA chart, on hover it shows the features & possible allophones for the given IPA */
export function IpaNAllophoneChart() {
  const [hovered, setHovered] = useState('');
  const [features, setFeatures] = useState('');
  const [allophones, setAllophones] = useState('');

  function onHover(ipa: IpaType) {
    if (ipa === '•') return;
    setHovered(ipa);
    setFeatures(getFeatureString(ipa));
    setAllophones(worldAllophones[ipa] ?? ipa);
  }

  return (<div style={{ textAlign: 'left' }}>
    <IpaChart lookup={(ipa: IpaType) => ipa} combinedConsonants={true} misc={true}
      clicked={(ipa) => speakSample(ipa)} canClick={(ipa) => hasSample(ipa)}
      hovered={(ipa) => onHover(ipa)} />
    <br />
    <b>&nbsp;{`features of /${hovered}/:`}</b> {features}
    <br />
    <b>&nbsp;{`possible allophones of /${hovered}/:`}</b> {allophones}
  </div>);
}
